export const environment = {
  production: false,
  isOnlyDev: false,
  //INFO KEYCLOAK
  URL_KEYCLOAK: 'https://dev-login.minambiente.gov.co/',
  CLIENT_ID_KEYCLOAK: 'vital-public-ui',
  REALM_KEYCLOAK: 'ambiente',
  USER_KEYCLOAK_ENDPOINT: 'admin/realms/ambiente/users',
  AUTORIZE_KEYCLOAK_ENDPOINT: 'role-mappings/clients',

 //INFO GESTION SSO API
  URL_GESTION_SSO_API: 'https://dev-sso-api.minambiente.gov.co/v1',
  //URL_GESTION_SSO_API: 'http://localhost:8000/v1',
  
  PERSONA_JURIDICA_ENDPOINT: 'personaJuridica_ID',
  PERSONA_NATURAL_ENDPOINT: 'personaNatural_ID' ,
  REGISTRAR_PERSONA_ENDPOINT: 'RegistrarPersona' ,
  AUTORIZAR_USUARIO_ENDPOINT: 'autorizar_usuario',

// redireccion VITAL Operacion
  URL_VITAL_OPERACION: 'http://vital-dev.minambiente.gov.co',
  SILPA_LOGIN: 'Silpa/TestSilpa/Security/Login.aspx',

  // authenticaion digital gov co
  URL_AUTH_DIGITAL: 'https://qaautenticaciondigital.and.gov.co',


  URL_VITAL_OLD:'http://vital-qa.minambiente.gov.co',

  //GOOGLE ANALYTICS
  GOOGLE_ANALYTICS: 'G-MR9W18EYSD',

  // VITAL ADMIN
  URL_VITAL_ADMIN : 'https://dev-vital-admin.minambiente.gov.co/app/',

  CARD_VISIBLE: false,

  URL_BUSCADOR: 'https://dev-buscador-api.minambiente.gov.co/',

  VITAL_DOMINIO_REGEX : /vital-publico\.minambiente\.gov\.co/
};
